import api from "api";
import {
    setWorkFlowsList,
    setIsLoadingFetch,
    setStages,
    setIsLoadingStage,
} from "redux/workFlow.slice";
import { ResponseTransform } from "utils";

export const getWorkFlows = (idProject) => async (dispatch) => {
    dispatch(setIsLoadingFetch(true));
    const responseApi = await api.get(`api/workFlowType/project/${idProject}`).then(ResponseTransform);
    dispatch(setIsLoadingFetch(false));
    if (responseApi) {
        dispatch(setWorkFlowsList(responseApi));
    }
    return responseApi;
};

export const saveWorkFlow = (data) => async (dispatch) => {
    dispatch(setIsLoadingFetch(true));
    const responseApi = await api.post(`api/workFlowType`, data).then(ResponseTransform);
    dispatch(setIsLoadingFetch(false));
    if (responseApi) {
        dispatch(getWorkFlows(data.projectId));
    }
    return responseApi;
};

export const editWorkFlow = (data, idWorkFlow, projectId) => async (dispatch) => {
    dispatch(setIsLoadingFetch(true));
    const responseApi = await api.put(`api/workFlowType/${idWorkFlow}`, data).then(ResponseTransform);
    dispatch(setIsLoadingFetch(false));
    if (responseApi) {
        dispatch(getWorkFlows(projectId));
    }
    return responseApi;
};

export const getStages = (idWorkFlow) => async (dispatch) => {
    dispatch(setIsLoadingStage(true));
    let responseApi = await api.get(`api/stage/workflowtype/${idWorkFlow}`).then(ResponseTransform);
    dispatch(setIsLoadingStage(false));
    if (responseApi) {
        if (responseApi.length > 0) responseApi = responseApi.sort((a, b) => a.order - b.order);
        dispatch(setStages(responseApi));
    }
    return responseApi;
};

export const updateStages = async (data) => {
    const responseApi = await api.post(`api/stage/add-delete-update-range`, data).then(ResponseTransform);
    return responseApi;
};

export const savePoll = async (data) => {
    const responseApi = await api.post(`api/poll`, data).then(ResponseTransform);
    return responseApi;
};

export const updatePoll = async (data, idPoll) => {
    const responseApi = await api.put(`api/poll/${idPoll}`, data).then(ResponseTransform);
    return responseApi;
};

export const updateActionsPoll = async (data) => {
    const responseApi = await api.post(`api/poll/create-update-delete`, data).then(ResponseTransform);
    return responseApi;
};

export const deletePoll = async (idPoll) => {
    const responseApi = await api.remove(`api/poll/${idPoll}`).then(ResponseTransform);
    return responseApi;
};

export const getQuestionsByPoll = async (idPoll) => {
    const responseApi = await api.get(`api/question/poll/${idPoll}`).then(ResponseTransform);
    return responseApi;
};

export const getCatalogQuestion = async () => {
    const responseApi = await api.get(`api/question`).then(ResponseTransform);
    return responseApi;
};

export const getCatalogComponents = async () => {
    const responseApi = await api.get(`api/question/component`).then(ResponseTransform);
    return responseApi;
};

export const getGroupOptions = async () => {
    const responseApi = await api.get(`api/groupsOption`).then(ResponseTransform);
    return responseApi;
};

export const saveQuestionByPoll = async (data) => {
    const responseApi = await api.post(`api/question`, data).then(ResponseTransform);
    return responseApi;
};

export const deleteQuestion = async (idQuestion) => {
    const responseApi = await api.remove(`api/question/${idQuestion}`).then(ResponseTransform);
    return responseApi;
};